'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { ChangeArrow } from 'foundations-components/transitional/components/ChangeArrow';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { getCompareLabel } from 'reporting-ui-components/lib/compare-options';
import { ReportType } from 'reporting-ui-components/types/ReportTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DeltaDisplay = ({
  deltaRate,
  report
}) => {
  if (deltaRate == null) {
    return null;
  }
  const dateRange = report.getIn(['config', 'filters', 'dateRange', 'value']);
  const value = report.getIn(['config', 'compare']);
  if (deltaRate === Infinity || typeof deltaRate === 'number' && isNaN(deltaRate)) {
    return /*#__PURE__*/_jsx(Text, {
      color: "fill-accent-neutral-default",
      typography: "detail-200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'reporting-ui-components.customWidgets.performanceWidget.noDataForCompare',
        options: {
          comparePeriod: getCompareLabel({
            dateRange,
            value,
            explicit: false
          })
        }
      })
    });
  }
  return /*#__PURE__*/_jsxs(Text, {
    color: "fill-accent-neutral-default",
    typography: "detail-200",
    children: [/*#__PURE__*/_jsx(ChangeArrow, {
      use: deltaRate > 0 ? 'increase' : 'decrease'
    }), /*#__PURE__*/_jsx(FormattedPercentage, {
      value: Math.abs(deltaRate) * 100,
      precision: 2
    })]
  });
};
DeltaDisplay.propTypes = {
  deltaRate: PropTypes.number,
  report: ReportType.isRequired
};
export default DeltaDisplay;